/**
 * Complete Your Sleep — scroll-snap carousel.
 * Desktop (≥1024): arrows hidden unless 5+ products (.cys-section--scrollable).
 * Prev/next scroll by one card; arrows hide at the ends (no wrap).
 */
(function () {
  'use strict';

  function initCarousel(root) {
    var track = root.querySelector('[data-cys-track]');
    var prev = root.querySelector('[data-cys-prev]');
    var next = root.querySelector('[data-cys-next]');
    var dots = root.querySelectorAll('[data-cys-dot]');
    if (!track) return;

    function cards() {
      return Array.prototype.slice.call(track.querySelectorAll('.cys-card'));
    }

    function cardStep() {
      var list = cards();
      if (!list.length) return track.clientWidth || 0;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return list[0].getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function canScroll() {
      return maxScroll() > 2;
    }

    function atStart() {
      return track.scrollLeft <= 2;
    }

    function atEnd() {
      return track.scrollLeft >= maxScroll() - 2;
    }

    function setNavState(btn, enabled) {
      if (!btn) return;
      if (enabled) {
        btn.removeAttribute('disabled');
        btn.setAttribute('aria-disabled', 'false');
        btn.removeAttribute('hidden');
      } else {
        btn.setAttribute('disabled', '');
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('hidden', '');
      }
    }

    function updateNav() {
      var enable = canScroll();
      setNavState(prev, enable && !atStart());
      setNavState(next, enable && !atEnd());
    }

    function activeDotIndex() {
      var step = cardStep();
      if (!step) return 0;
      return Math.round(track.scrollLeft / step);
    }

    function updateDots() {
      if (!dots || !dots.length) return;
      var idx = activeDotIndex();
      dots.forEach(function (d, i) {
        var active = i === idx;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function updateMediaHalf() {
      var media = root.querySelector('.cys-card__media');
      if (!media) return;
      root.style.setProperty('--cys-media-half', media.offsetHeight / 2 + 'px');
    }

    function scrollByStep(direction) {
      var step = cardStep();
      if (!step || !canScroll()) return;
      if (direction > 0 && atEnd()) return;
      if (direction < 0 && atStart()) return;

      track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    if (prev) {
      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        scrollByStep(-1);
      });
    }

    if (next) {
      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        scrollByStep(1);
      });
    }

    if (dots && dots.length) {
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var idx = parseInt(d.getAttribute('data-cys-dot') || '0', 10);
          track.scrollTo({ left: idx * cardStep(), behavior: 'smooth' });
        });
      });
    }

    var scrollTimer = null;
    track.addEventListener(
      'scroll',
      function () {
        if (scrollTimer) window.cancelAnimationFrame(scrollTimer);
        scrollTimer = window.requestAnimationFrame(function () {
          updateNav();
          updateDots();
        });
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      function () {
        updateNav();
        updateDots();
        updateMediaHalf();
      },
      { passive: true }
    );

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        updateMediaHalf();
        updateNav();
      });
      var firstMedia = root.querySelector('.cys-card__media');
      if (firstMedia) ro.observe(firstMedia);
      ro.observe(track);
    }

    updateMediaHalf();
    updateNav();
    updateDots();
  }

  function init() {
    document.querySelectorAll('[data-cys-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
